<!-- <app-menu-bar></app-menu-bar> -->
<app-menu-bar-cliente></app-menu-bar-cliente>
<router-outlet></router-outlet>
